interface GradientTextProps {
  children: React.ReactNode;
  gradient?: string;
  shadow?: string;
  fontFamily?: string;
  className?: string;
}

const GradientText = ({
  children,
  gradient = '-webkit-linear-gradient(300deg, #5FD5DE 0%, #C0DE60 100%)',
  shadow = '0 4px 20px #63d5d9b3',
  fontFamily = 'LibreCaslonText',
  className = ''
}: GradientTextProps) => (
  <span
    style={{
      background: gradient,
      WebkitTextFillColor: 'transparent',
      WebkitBackgroundClip: 'text',
      textShadow: shadow,
      fontStyle: 'italic',
      fontFamily,
      marginLeft: '-.325em',
      marginRight: '-.325em',
      paddingLeft: '.325em',
      paddingRight: '.325em'
    }}
    className={className}>
    {children}
  </span>
);

export default GradientText;
